import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./Employee/Main";
import Form from "./Employee/Form";

// Utils
import { getData, getAlert, getDataWithComp } from "../../../utils/SamuiUtils";
import { InitialDataEmployee } from "../../../model/InitialData/InitialDataEmployee";

const Employee = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [dataEmpPosition, setDataEmpPosition] = useState([]);
  const [dataEmpDept, setDataEmpDept] = useState([]);
  const [dlLineList, setDlLineList] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState(InitialDataEmployee());
  const [activeAfterSaveId, setActiveAfterSaveId] = useState(null);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async (editedId) => {
    try {
      if (editedId != null) {
        setActiveAfterSaveId(editedId);
        await fetchRealtime();
      }
      setMode("S");
      if (editedId == null) fetchRealtime();
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      // ดึงข้อมูลจาก Tb_Set_Employee ทั้งหมด
      const masterList = await getDataWithComp(
        "View_Set_Employee",
        "Order By Emp_Id"
      );
      const dataPosition = await getData("Tb_Set_Position", "1=1");
      const dataDept = await getDataWithComp("Tb_Set_Dept", "ORDER BY Dept_Name ASC");

      // ดึงข้อมูลสายส่งสำหรับโรงน้ำแข็ง
      if (localStorage.getItem("company") === "2") {
        const dlData = await getDataWithComp("DL_Line_H", "ORDER BY DL_LineName ASC");
        if (dlData && dlData.length > 0) {
          setDlLineList(dlData);
        }
      }

      if (masterList && masterList.length > 0) {
        masterList.sort((a, b) => a.Emp_Id - b.Emp_Id);
        setDataMasterList(masterList);
      }
      if (dataPosition && dataPosition.length > 0) {
        setDataEmpPosition(dataPosition);
      }

      if (dataDept && dataDept.length > 0) {
        setDataEmpDept(dataDept);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onRowSelected = (item) => {
    setMode("U");

    const deliveryName =
      dlLineList && dlLineList.length > 0 && item.Emp_Delivery_Id
        ? (dlLineList.find((d) => d.DL_Id === item.Emp_Delivery_Id) || {}).DL_LineName
        : null;

    setFormData({
      emp_id: item.Emp_Id,
      emp_code: item.Emp_Code,
      emp_prefix: item.Emp_Prefix,
      emp_name: item.Emp_Name,
      emp_dept: item.Dept_Name,
      emp_position: item.Emp_Position,
      emp_position_detail: item.Emp_Position_Detail,
      emp_startdate: item.Emp_StartDate,
      emp_tel: item.Emp_Tel,
      emp_status: item.Emp_Status,
      emp_uuser: item.Emp_UUser,
      emp_ppass: item.Emp_PPass,
      emp_pin: item.Emp_PIN,
      comp_id: item.Comp_Id,
      emp_delivery_id: item.Emp_Delivery_Id || null,
      emp_delivery_name: deliveryName || null,
    });
    setSelectedData(item);
  };

  return (
    <div className="Creditor">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              <div style={{ display: mode === "S" ? "block" : "none" }}>
                <Main
                  masterList={dataMasterList}
                  name={"ข้อมูลพนักงาน"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(item) => onRowSelected(item)}
                  activeAfterSaveId={activeAfterSaveId}
                  onClearActiveAfterSave={() => setActiveAfterSaveId(null)}
                  idField="Emp_Id"
                />
              </div>
              <div style={{ display: mode !== "S" ? "block" : "none" }}>
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ข้อมูลพนักงาน"}
                  formData={formData}
                  setFormData={setFormData}
                  selectedData={selectedData}
                  dataEmpPosition={dataEmpPosition}
                  dataEmpDept={dataEmpDept}
                  dlLineList={dlLineList}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Employee;
